import { getErrorCode, parseErrorMessage } from 'src/services/repository/utils-repository'

import UserRepositories from './commons/user.repository'
import RoleRepositories from './commons/role.repository'
import PartTypeRepositories from './commons/partType.repository'
import PartNumberRepositories from './commons/partNumber.repository'
import PartRepositories from './commons/part.repository'
import RecordRepositories from './commons/record.repository'
import RejectionCauseRepositories from './commons/rejectionCause.repository'
import BatchRepositories from './commons/batch.repository'

import MeRepository from './commons/me.repository'

export default {
  getErrorCode,
  parseErrorMessage,
  me: MeRepository,
  user: UserRepositories,
  role: RoleRepositories,
  partType: PartTypeRepositories,
  partNumber: PartNumberRepositories,
  part: PartRepositories,
  record: RecordRepositories,
  rejectionCause: RejectionCauseRepositories,
  batch: BatchRepositories,
}
